export const LOGIN_SUCCESS_EVENT = {
  event: 'interaction_login',
  amp_event_name: 'Login',
};
